// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { FlyoverPlayer, type FlyoverPlayerProps } from './FlyoverPlayer';
import { useLandscapeFlyoverUrls } from './useFlyoverVideos';

export type HolePreviewMediaProps = Omit<FlyoverPlayerProps, 'videoUrlByHole'> & {
  apiBaseUrl: string;
  token: string | null | undefined;
  courseId: string | null;
};

/**
 * One course preview, whichever medium each hole has: the server-rendered 3D flyover
 * video where one exists, the live 2D flyover everywhere else. Callers never choose —
 * the seam is here, so courses gain videos with no caller changes.
 */
export function HolePreviewMedia({ apiBaseUrl, token, courseId, ...flyoverProps }: HolePreviewMediaProps) {
  const videoUrlByHole = useLandscapeFlyoverUrls(apiBaseUrl, token, courseId, courseId !== null);
  return <FlyoverPlayer {...flyoverProps} videoUrlByHole={videoUrlByHole} />;
}
